import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './Visuals/Colors';
import React, { useEffect, useState } from 'react';

// Pages
import NavBar from './Routes/MainComponents/navigation/NavbarComponent.component';
import Footer from './Routes/MainComponents/footer/FooterComponent.component';
import CookieConstent from './Cookies/CookieBanner.component';
import UnsubscribeFromNewsletter from './Newsletter/UnsubscribeNewsletter.component';
import BasePage from './Routes/MainComponents/base/BasePage.component';
// Main Page
import AboutUs from './Routes/AboutUs/AboutUsPage.component';
import ProgramDevelopment from './Routes/ProgramDevelopment/ProgramPage.component';
import Insurance from './Routes/Insurances/InsurancePage.component';
import CompanySignupPage from './Authentication/CompSignUp/SignUpCompany.component';
import Resources from './Routes/Resources/ResourcePage.component';
import WCBCertified from './Routes/WcbCertified/WcbPage.component';
import OnlineTraining from './OnlineTraining/TrainingOnlinePage.component';
import ClassroomTraining from './Routes/Classroom/TrainingClassroomPage.component';
import NotFound from './Routes/MainComponents/not-found/NotFoundPage.component';
import PrivacyPolicy from './Routes/PrivacyPolicy/PrivacyPolicyPage.component';
import TermsAndConditions from './Routes/Terms&Conditions/TermsAndConditionsPage.component';
import ContactUs from './Routes/ContactUs/ContactUs.component';
import BuyCourse from './OnlineTraining/Purchase/BuyPage.component';
import Purchase from './OnlineTraining/Purchase/Purchase.component';
// Authentication
import SignUpComponent from './Authentication/SignupPage.component';
import LoginComponent from './Authentication/LoginPage.component';
import ForgotPassword from './Authentication/PasswordReset/ForgotPassword';
import ResetPassword from './Authentication/PasswordReset/ResetPassword';
import Unauthorized from './Unauthorized/UnauthorizedComponent.component';

//Admin: Protected with AuthCheckAdmin
import Admin from './AdminRoutes/Admin/AdminHome.component';
import CreateUser from './AdminRoutes/CreateRoutes/CreateUser/UserCreate.component';
import CreateCompany from './AdminRoutes/CreateRoutes/CreateCompany/CompanyCreate.component';
import CreateCourse from './AdminRoutes/CreateRoutes/CreateCourse/CourseCreate.component';
import CreateNewsletter from './AdminRoutes/CreateRoutes/CreateNewsletter/NewsletterCreate.component';
import EditCourse from './AdminRoutes/EditRoutes/EditCourse/CourseEdit.component';
import EditUser from './AdminRoutes/EditRoutes/EditUser/EditUserPage/UserEdit.component.jsx';
import EditCompany from './AdminRoutes/EditRoutes/EditCompany/CompanyEdit.component';
import EditManagersAndUsers from './AdminRoutes/EditRoutes/EditManagers/ManagersEdit.componentPage';
import EditNewsletter from './AdminRoutes/EditRoutes/EditNewsletter/NewsEdit.component';
import UserCourseDetails from './AdminRoutes/EditRoutes/EditUser/UserCoursesPage/UserCourseDetails.component.jsx';
import UserCourses from './AdminRoutes/EditRoutes/EditUser/UserCoursesPage/UserCourses.component.jsx';
import GetInfo from './AdminRoutes/GetInformation/GetInfo.component';
import NewslettersSubscribersList from './AdminRoutes/Admin/NewsletterSubscribers.component';
import CoursesTab from './AdminRoutes/Admin/Courses/CoursesTabComponent.component';
import CompanyAdminHome from './AdminRoutes/Admin/Companies/CompaniesHome/CompanyHomepage.component';
import PurchaseHistoryAdmin from './AdminRoutes/Admin/Companies/Purchases/PurchaseHistory.component';
import UserAdminHome from './AdminRoutes/Admin/Users/UserHome/UserHomepage.component.jsx';
import PurchaseHistory from './CompanyRoutes/PurchaseHistory/PurchasedHistory.component';
import PurchaseHistoryOfUserAdmin from './AdminRoutes/EditRoutes/EditUser/PurchaseHistoryPage/PurchaseHistory.component.jsx';

//User: Protected with AuthCheckUser
import UserHome from './UserRoutes/UserHomepage/UserHomePage.component';
import UserSettings from './UserRoutes/UserSettings/UserSettingsHome.component';
import AllCoursesPage from './UserRoutes/UserHomepage/UserAllCourses.component';
import UserPurchaseHistory from './UserRoutes/PurchaseHistory/UserPurchaseHistory.component';
import PurchaseCompleted from './OnlineTraining/Purchase/CompleteTransaction.component';

//Course: Protected with AuthCheckUser
//import BuyCourse from './BuyCourse/BuyCoursePage/buyCourse.component';
import QuizComponent from './TrainingRoutes/Quiz/QuizHomepage.component';
import CourseComplete from './TrainingRoutes/FinishedCourse/Completed/QuizCompletePage.component';
import IncompleteCourse from './TrainingRoutes/FinishedCourse/Incomplete/QuizIncompletePage.component';
import CourseHomepage from './TrainingRoutes/TakeCourse/CourseHomepage.component';
import SingleCourse from './OnlineTraining/DisplayCourseInfo/EachCoursePage.component';
import CourseReview from './TrainingRoutes/ReviewCourse/CourseReview.component';

// Company: Protected with AuthCheckManager - Imported but commented out until development is finished
import EditManagerOrEmployee from './AdminRoutes/EditRoutes/EditManagers/EditManagerOrEmployee';
import CompanyHome from './CompanyRoutes/CompanyHomepage/CompanyHome.component';
import UploadForm from './CompanyRoutes/CreateRoutes/UploadForm/UploadForms.component';
import CreateSubcontractor from './CompanyRoutes/CreateRoutes/CreateSubContractor/Subcontractor.component';
import EditForm from './CompanyRoutes/EditRoutes/EditForm/EditForms.component';
import CreateManagerCompany from './CompanyRoutes/CreateRoutes/CreateManagerEmployee/CreateME.component';
import CompanyFormsPage from './CompanyRoutes/CompanyHomepage/CompanyForms.component';
import CompanyEmployeesPage from './CompanyRoutes/CompanyHomepage/CompanyEmployees.component';
import CompanySettingsPage from './CompanyRoutes/CompanySetting/CompanySettings.component';
// import CompanyUserCourseDetials from './AdminRoutes/EditRoutes/EditUser/CourseDetails/Company/CompanyUserDetails.component';
// Contractor Management:
import ContractorLoginComponent from './ContractorManagement/ContractorLogin/ContractorLogin.component';
import ContractorManagementHome from './ContractorManagement/ContractorHome/ContractorHome.component';

import TDGCertificateHomepage from './TrainingRoutes/Certificates/TDGCertificate/TDGCertHomepage.component';
import CreateImage from './AdminRoutes/CreateRoutes/CreateImage/CreateImage.component';
import NewsletterModal from './Newsletter/NewsletterModal.component';
import IPHomepage from './Ip/IpHomepage.component';
import CompanyPurchaseCourses from './CompanyRoutes/CompanyBuyCourses/CompanyBuyCourse.component';
import DiscountHomepage from './AdminRoutes/CreateRoutes/CreateDiscount/DiscountHomepage.component';
import CompaniesTab from './AdminRoutes/Admin/Companies/CompaniesTabComponent.component';
import UsersTab from './AdminRoutes/Admin/Users/UserTabComponent.component';
import NewsletterTab from './AdminRoutes/Admin/Newsletters/NewsletterTab.component';
import TryMe from './Components/TryMe.component.jsx';
// let UserCourseDetails;
let CompanyUserCourseDetials;

function App() {
  const [showEmailModal, setShowEmailModal] = useState(false);
  useEffect(() => {
    const isFirstVisit = localStorage.getItem('isFirstVisit');
    if (!isFirstVisit) {
      setShowEmailModal(true);
      localStorage.setItem('isFirstVisit', 'false');
    }
  }, []);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <div style={{ flex: '1 0 auto' }}>
            <NavBar />
            <CookieConstent />
            {showEmailModal && (
              <NewsletterModal setShowEmailModal={setShowEmailModal} />
            )}
            <Routes>
              {/* <PublicRoutes /> */}
              {/* Main public routes */}
              <Route path="/" element={<BasePage />}>
                <Route index element={<AboutUs />} />
                <Route path="program" element={<ProgramDevelopment />} />
                <Route path="purchase" element={<Purchase />} />
                <Route
                  path="terms-and-conditions"
                  element={<TermsAndConditions />}
                />
                <Route
                  path="unsubscribe-from-newsletter"
                  element={<UnsubscribeFromNewsletter />}
                />
                <Route path="checkout" element={<BuyCourse />} />
                <Route
                  path="transaction-completed"
                  element={<PurchaseCompleted />}
                />
                <Route path="contact-us" element={<ContactUs />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />} />
                <Route path="resources" element={<Resources />} />
                <Route path="insurance" element={<Insurance />} />
                <Route path="wcb-certified" element={<WCBCertified />} />
                <Route path="online" element={<OnlineTraining />} />
                <Route path="classroom" element={<ClassroomTraining />} />
                <Route path="company-signup" element={<CompanySignupPage />} />
                <Route path="loading" element={<TryMe />} />
                <Route path="signup" element={<SignUpComponent />} />
                <Route path="login" element={<BasePage />}>
                  <Route index element={<LoginComponent />} />
                  <Route path="forgot-password" element={<ForgotPassword />} />
                  <Route
                    path="reset-password/:token"
                    element={<ResetPassword />}
                  />
                </Route>
                <Route path="unauthorized" element={<Unauthorized />} />
              </Route>
              {/* Admin Routes  */}
              <Route path="/admin" element={<BasePage />}>
                <Route index element={<Admin />} />
                <Route path="create-course" element={<CreateCourse />} />
                <Route path="create-company" element={<CreateCompany />} />
                <Route path="create-user" element={<CreateUser />} />
                <Route path="create-image" element={<CreateImage />} />
                <Route path="information" element={<GetInfo />} />
                <Route path="discounts" element={<DiscountHomepage />} />
                <Route
                  path="newsletter-subscribers"
                  element={<NewslettersSubscribersList />}
                />
                <Route
                  path="certificate/:id/course/:courseId"
                  element={<UserCourseDetails />}
                />
                <Route
                  path="create-newsletter"
                  element={<CreateNewsletter />}
                />
                {/* <Route path='course' element={<AllCourses />} /> */}
                <Route path="edit-user/:id" element={<EditUser />} />
                <Route
                  path="edit-user/:id/course/:courseId"
                  element={<UserCourseDetails />}
                />
                <Route
                  path="company/purchase-history/:id"
                  element={<PurchaseHistoryAdmin />}
                />
                <Route
                  path="edit-newsletter/:id"
                  element={<EditNewsletter />}
                />
                <Route path="edit-course/:id" element={<EditCourse />} />
                <Route
                  path="company/employees/:id"
                  element={<EditManagersAndUsers />}
                />
                <Route
                  path="company/:id/employee/:userId"
                  element={<EditManagerOrEmployee />}
                />
                <Route path="company/edit/:id" element={<EditCompany />} />
                <Route path="company-home/:id" element={<CompanyAdminHome />} />
                <Route path="user-home/:id" element={<UserAdminHome />} />
                <Route path="user/courses/:id" element={<UserCourses />} />
                <Route
                  path="user/purchase-history/:id"
                  element={<PurchaseHistoryOfUserAdmin />}
                />
                <Route path="courses" element={<CoursesTab />} />
                <Route path="companies" element={<CompaniesTab />} />
                <Route path="users" element={<UsersTab />} />
                <Route path="newsletters" element={<NewsletterTab />} />
              </Route>
              {/* User Routes */}
              <Route path="/user" element={<BasePage />}>
                <Route index element={<UserHome />} />
                <Route path="settings/:id" element={<UserSettings />} />
                <Route path="all-courses" element={<AllCoursesPage />} />
                <Route
                  path="purchase-history"
                  element={<UserPurchaseHistory />}
                />
              </Route>

              {/* Course Routes */}
              <Route path="course" element={<BasePage />}>
                <Route index path=":id" element={<SingleCourse />} />
                <Route path="home/:id" element={<CourseHomepage />} />
                <Route path="quiz/:id" element={<QuizComponent />}></Route>
                <Route path="quiz/complete/:id" element={<CourseComplete />} />
                <Route
                  path="tdg-certificate/:id"
                  element={<TDGCertificateHomepage />}
                />
                <Route
                  path="quiz/incomplete/:id"
                  element={<IncompleteCourse />}
                />
                <Route path="review/:id" element={<CourseReview />} />
              </Route>

              {/* Company Routes */}
              <Route path="company" element={<BasePage />}>
                <Route index element={<CompanyHome />} />
                <Route path="upload-form/:id" element={<UploadForm />} />
                <Route
                  path="edit-manager-employee/:userId"
                  element={<EditManagerOrEmployee />}
                />
                <Route
                  path="create-manager-employee/:id"
                  element={<CreateManagerCompany />}
                />
                <Route
                  path="purchase-history/:id"
                  element={<PurchaseHistory />}
                />
                <Route
                  path="create-subcontractor/:id"
                  element={<CreateSubcontractor />}
                />
                {/* Change this one to company */}
                <Route
                  path="certificate/:id/course/:courseId"
                  element={<CompanyUserCourseDetials />}
                />
                <Route
                  path="buy-courses/:companyId"
                  element={<CompanyPurchaseCourses />}
                />
                <Route path="forms/:id" element={<CompanyFormsPage />} />
                <Route
                  path="employees/:id"
                  element={<CompanyEmployeesPage />}
                />
                <Route path="settings/:id" element={<CompanySettingsPage />} />
                <Route path=":id/edit-form/:formId" element={<EditForm />} />
              </Route>

              {/* Contractor Management Routes */}
              <Route path="contractor-management" element={<BasePage />}>
                <Route index element={<ContractorManagementHome />} />
                <Route path="login" element={<ContractorLoginComponent />} />
              </Route>
              {/* IP Routes */}
              <Route path="inspection-pal" element={<BasePage />}>
                <Route index element={<IPHomepage />} />
              </Route>
              {/* <Route path='cart/:id' element={<BuyCourse />} /> */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
